import { render, staticRenderFns } from "./OrderBusinessAppraisePageForGov.vue?vue&type=template&id=6f61c69e&scoped=true&"
import script from "./OrderBusinessAppraisePageForGov.vue?vue&type=script&lang=js&"
export * from "./OrderBusinessAppraisePageForGov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f61c69e",
  null
  
)

export default component.exports